import { createClient } from '@supabase/supabase-js'
import { getSessionId, getFacilityId } from './session'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const trackPageView = async (pageName, categoryId, subcategoryId) => {
  try {
    const sessionId = getSessionId();
    const facilityId = getFacilityId();
    
    const { data, error } = await supabase
      .from('page_views')
      .insert([
        {
          page_name: pageName,
          category_id: categoryId,
          subcategory_id: subcategoryId,
          session_id: sessionId,
          facility_id: facilityId,
          host: window.location.host,
          referrer: document.referrer || null,
          timestamp: new Date().toISOString()
        }
      ])
    
    if (error) throw error
    return data
  } catch (error) {
    console.error('Error tracking page view:', error.message)
  }
} 